<template>
  <div class="tw-p-4 shadow-1 card tw-bg-white">
    <crud-form
      v-if="form.dadosForm"
      ref="jtDynamicForm"
      :form="form"
      :model="form.dadosForm"
      @action-click="onFormButtonClick"
    >
      <span class="Dados-do-Solicitante">
        {{ $gettext("APPLICANT_DATA") }}</span
      >
      <div class="Margin-Dados-solicitante"></div>
      <div class="content-wrapper">
        <div class="left-section">
          <div class="inputs-grid">
            <crud-input
              class="input-item input-id"
              ref="clientID"
              nmInput="clientID"
            />
            <crud-input
              class="input-item input-name"
              ref="clientName"
              nmInput="clientName"
            />
            <crud-input
              class="input-item input-email"
              ref="clientEmail"
              nmInput="clientEmail"
            />
            <crud-input
              class="input-item input-phone"
              ref="clientPhone"
              nmInput="clientPhone"
            />
            <crud-input
              class="input-item input-full"
              ref="serviceRequestClassification"
              nmInput="serviceRequestClassification"
            />
            <crud-input
              class="input-item input-full"
              ref="serviceObservation"
              nmInput="serviceObservation"
            />
          </div>

          <span class="Dados-do-Solicitante history-title">
            {{ $gettext("SERVICE_REQUEST_HISTORY") }}
          </span>
          <jt-data-table
            v-if="tableLoaded"
            :pagination="pagination"
            :rows-per-page-options="[0]"
            :api-mode="false"
            :data="historyDataTable"
            :fields="fields"
            class="data-table-wrapper"
            noneselect
          />
        </div>
        <div class="right-section">
  <div class="combo-wrapper">
    <div class="combo-container">
      <crud-input nmInput="origin" />
    </div>
    <div class="combo-container">
      <crud-input nmInput="type" />
    </div>
  </div>
</div>
      </div>
      <q-separator />
      <div class="buttons-wrapper">
        <div class="button-item" v-if="form.dadosForm">
          <q-btn
            :disable="disableButton"
            class="full-width"
            color="grey"
            @click="onFormButtonClick()"
          >
            <q-icon size="18px" class="position-icon-filter" />
            {{ $gettext("IGNORE_ATENDIMENTO") }}
          </q-btn>
        </div>
        <div class="button-item" v-if="form.dadosForm">
        <q-btn
            :disable="disableButton"
            class="full-width"
            color="green"
            @click="onFormButtonClick()"
          >
            <q-icon size="18px" class="position-icon-filter" />
            {{ $gettext("START_ATTENDANCE") }}
          </q-btn>
        </div>
      </div>
    </crud-form>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import ServiceRequestController from '../ServiceRequestController'
import ServiceRequestModel from '../ServiceRequestModel'
import ServiceObservationController from '../../service-request/view/registration-information/service-observation/ServiceObservationController'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { messageBox } from 'jtech'
const { form, input } = JtCrud

@Component({
  name: 'ServiceRequestStart',
  components: {
    'crud-form': form,
    'crud-input': input,
    JtDataTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ServiceRequestStart extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  controllerObservation = ServiceObservationController.getInstance();
  forms = [];
  clientID = null;
  historyForm = { columns: [] };
  historyDataTable = [];
  pagination = {
    rowsPerPage: 5
  };

  tableLoaded = false;

  @Watch('clientIDComponent')
  async onClientIDChange (clientID) {
    if ((clientID + '').length === 14) {
      const params = await this.controller.searchClient({
        document: clientID
      })
      this.form.dadosForm = {
        ...this.form.dadosForm,
        ...params,
        clientName: params.name,
        clientPhone: params.phone || params.alternativePhone,
        clientEmail: params.email
      }
      const { registros } = await this.controller.loadHistoryData(
        this.clientIDComponent
      )
      this.historyDataTable = registros
    } else {
      this.historyDataTable = []
    }
  }

  get form () {
    return this.forms && this.forms[0] ? this.forms[0] : {}
  }

  get fields () {
    return Object.keys(this.historyForm).length ? this.historyForm.columns : []
  }

  get disableButton () {
    return !(
      this.form.dadosForm.origin &&
      this.form.dadosForm.type &&
      this.$refs.jtDynamicForm &&
      this.$refs.jtDynamicForm.isValidForm()
    )
  }

  getLabelInput (nmPropriedade) {
    try {
      return (
        this.find(this.form.inputs, function (input) {
          return input.model == nmPropriedade
        }).label + ':'
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        'ServiceRequestStart.pesquisarLabel: ' + nmPropriedade,
        error
      )
    }
    return nmPropriedade
  }

  get clientIDComponent () {
    return this.form.dadosForm ? this.form.dadosForm.clientID : ''
  }

  async mounted () {
    await this.reload()
  }

  async reload () {
    this.forms = await this.controller.start()
    const historyForm = await this.controller.loadHistoryForm()
    this.historyForm = historyForm
    this.historyDataTable = []
    this.form.dadosForm = {
      ...this.form.dadosForm,
      clientName: '',
      clientPhone: '',
      clientEmail: '',
      serviceObservation: ''
    }
    this.tableLoaded = true
  }

  onFormButtonClick () {
    this.controller.router({
      name: 'serviceRequest.create',
      params: { ...this.form.dadosForm, client: this.form.dadosForm.id }
    })
  }
}
export default ServiceRequestStart
</script>
<style scoped>
.Dados-do-Solicitante {
  margin: auto 0 0 0;
  font-family: Roboto;
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #394053;
}

.card {
  margin: 2.75rem 1rem 0 1rem;
}

.Margin-Dados-solicitante {
  height: 1px;
  margin: 8px 0px 19px 0;
  background-color: #cad5db;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 300px;
}

@media (min-width: 1024px) {
  .content-wrapper {
    flex-direction: row;
    min-height: 69vh;
    gap: 1.5rem;
  }
}

.left-section {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

@media (min-width: 1024px) {
  .left-section {
    flex: 0 0 66.666667%;
  }
}

.inputs-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.input-item {
  flex: 1 1 100%;
  min-width: 0;
  padding: 0 0.5rem;
}

@media (min-width: 640px) {
  .input-id {
    flex: 1 1 calc(25% - 0.5rem);
  }

  .input-name {
    flex: 1 1 calc(40% - 0.5rem);
  }

  .input-email {
    flex: 1 1 calc(35% - 0.5rem);
  }

  .input-phone {
    flex: 1 1 calc(25% - 0.5rem);
  }
}

@media (min-width: 1024px) {
  .input-id {
    flex: 0 0 calc(16.666667% - 0.5rem);
  }

  .input-name {
    flex: 0 0 calc(33.333333% - 0.5rem);
  }

  .input-email {
    flex: 0 0 calc(33.333333% - 0.5rem);
  }

  .input-phone {
    flex: 0 0 calc(16.666667% - 0.5rem);
  }
}

.input-full {
  flex: 1 1 100%;
}

.history-title {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.data-table-wrapper {
  flex: 1;
  min-height: 300px;
  max-height: 400px;
  overflow: auto;
  padding: 0 0.75rem;
  margin-bottom: 1rem;
}

.right-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0.75rem;
}

@media (min-width: 1024px) {
  .right-section {
    flex: 0 0 33.333333%;
    padding-left: 1rem;
    margin-top: -1.4vh;
  }
}

.combo {
  display: flex;
  width: 100%;
}

.combo-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1024px) {
  .combo-container {
    width: 260px;
  }
}

.combo-container ::v-deep .q-option-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 3px;
  row-gap: 1px;
}

.combo-container ::v-deep .q-option-group .q-radio {
  min-width: 110px;
}

.buttons-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 1.5rem 0;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
}

@media (min-width: 640px) {
  .buttons-wrapper {
    flex-direction: row;
    gap: 1.5rem;
  }
}

.button-item {
  width: 100%;
  max-width: 300px;
}

@media (min-width: 640px) {
  .button-item {
    width: auto;
    min-width: 200px;
  }
}

@media (min-width: 1024px) {
  .button-item {
    min-width: 16.666667%;
  }
}

.top-button {
  position: absolute;
  top: -3.5rem;
  right: 0rem;
}
</style>
